import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';
import { fmtLocalDate as fmtDate } from '../../../utils/dateUtils';

export default function DiscountDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  // DiscountDto uses nameLocalizations (LocalizedPairs) — not localizedName or localizedPairs.
  const nameData = data.nameLocalizations ?? data.localizedName ?? data.localizedPairs;
  const nameKey  = data.nameLocalizations ? 'nameLocalizations' : (data.localizedName ? 'localizedName' : 'localizedPairs');

  const discountValue = data.ratePct != null
    ? `${data.ratePct}% off`
    : data.amount != null
      ? `${data.amount} flat`
      : null;

  return (
    <Box>
      <SectionBlock title="Identity" />
      <LocalizedField
        label="Name"
        fieldKey={nameKey}
        data={nameData}
        diffKeys={diffKeys}
        side={side}
      />
      <FieldRow
        label="Discount Type"
        value={data.discountTypeId != null ? String(data.discountTypeId) : null}
        isChanged={diffKeys.has('discountTypeId')}
        side={side}
      />
      <FieldRow
        label="Value"
        value={discountValue}
        isChanged={diffKeys.has('ratePct') || diffKeys.has('amount')}
        side={side}
      />

      <SectionBlock title="Schedule" />
      <FieldRow
        label="Start Date"
        value={fmtDate(data.startAt)}
        isChanged={diffKeys.has('startAt')}
        side={side}
      />
      <FieldRow
        label="End Date"
        value={fmtDate(data.endAt)}
        isChanged={diffKeys.has('endAt')}
        side={side}
      />
    </Box>
  );
}
